module.exports = __webpack_public_path__ + "img/banner.c02d6f35.png";